import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { registerUser } from "../modules/actions";
import { getSuppliers } from "../../Dobavljaci/modules/actions";
import Register from "./View";

const mapStateToProps = (state) => ({
  userState: {
    resetRegisterFields: state.user.resetRegisterFields,
    suppliersOptions: state.suppliersReducer.suppliers,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      registerUser,
      getSuppliers,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
